<template>
  <div class="col-md-12 button">
    <button @click="onClick" class="button-search" :style="styleObject">
      <span class="button-validate" v-if="haveLoading">
        <span v-if="!loading" class="button-label">{{ label }}</span>
        <div v-else class="loading-btn button-loading">
          <div class="spinner-btn button-spinner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
          </div>
        </div>
      </span>
      <span class="button-validate" v-else>
        <span class="button-label">{{ label }}</span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: "btnDefault",
  props: {
    label: {
      required: true,
    },
    loading: {
      default: false,
    },
    haveLoading: {
      default: false,
    },
    background: '',
    backgroundHover: '',
    color: '',
    colorHover: '',
    width: '',
  },
  methods: {
    onClick() {
      this.$emit('emit-click')
    }
  },
  computed: {
    styleObject() {
      return {
        '--color-default': this.color,
        '--color-hover-default': this.colorHover,
        '--background-default': this.background,
        '--background-hover-default': this.backgroundHover,
        'width': this.width
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.button {

  &-search {
    color: var(--color-default);
    background: var(--background-default);
    border: none;
    border-radius: 4px !important;
    padding: 11px 46px;
    transition: .2s;

    &:hover, &:active {
      color: var(--color-hover-default);
      background: var(--background-hover-default);
    }
  }

  &-search > &-validate > &-label {
    font-weight: 400;
    font-size: 14px;
    line-height: 130%;
    color: #FFFFFF;
  }

  &-loading > &-validate > &-spinner {
    > div {
      margin-right: 6.77px;
      height: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/buttons/btnDefault.vue